import vCheckbox from "./v-checkbox.vue";
import vCheckboxGroup from "./v-checkbox-group.vue";

export default Vue => {
  Vue.component("v-checkbox", vCheckbox);
  Vue.component("v-checkbox-group", vCheckboxGroup);
};
